import React from 'react';
import img2 from '../images/Instruction for correct pose during office work.jpg';
import {Container, Button, } from 'react-bootstrap';
export default function Section5() {
  return ( 
      <section className="section2">
        <div className=" row container-fluid col-12 d-flex "> 
            <div className="intro col-sm-12 col-md-6 col-lg-6 mx-auto">
                <Container> 
                    <div className='text'>
                        <h1 className='text-center'>Qualification</h1> 
                        <h6  >
                           <b>Education</b><br />
                            <ul>
                                <li>
                                    Studies Child Development at University of Dhaka.
                                </li>
                                <li>
                                    Completed HSC from National Ideal College.
                                </li>
                                <li>
                                    Studied at KPB School & College.
                                </li>
                            </ul>
                            <b>Skill</b><br />
                            <ul>
                                <li>
                                    Completed <b>UI/UX Design</b> from INSTRUCTORY.
                                </li>
                                <li>
                                    Completed <b>Wordpress Customization</b> From INSTRUCTORY.
                                </li>
                                <li>
                                    Completed <b>Graphic Design</b> from SHIKHBE SOBAL.
                                </li> 
                            </ul>
                        </h6>
                    </div> 
                    <div className='p-4'>
                        <Button variant='outline-dark'>
                            Know More
                        </Button>
                        {/* {' '} {' '} 
                        <Button variant='outline-dark'>
                            Download Resume
                        </Button>  */}
                    </div>
                    
                </Container>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-6 mx-auto">
                <img src= {img2} alt="illustration" />
            </div>
        </div> 
     </section> 
  )
}
